'use client';

import utilsStyles from '@/styles/modules/utils.module.scss';
import React from 'react';
import fontsStyles from '../../../styles/modules/fonts.module.scss';
import ActionButton from '../../form/ActionButton/ActionButton';
import FaIcon, { faTriangleExclamation } from '../../icon/FaIcon/FaIcon';
import ImageView from '../../ui/ImageView/ImageView';
import ModalBase from '../../ui/ModalBase/ModalBase';
import styles from './BenefitConfirmModal.module.scss';

export type BenefitConfirmModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  drawCount: number;
  benefitMultiDrawCount: number;
  prizeName: string;
  prizeThumbnailUrl?: string;
  noticeText?: string;
};

function BenefitConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  drawCount,
  benefitMultiDrawCount,
  prizeName,
  prizeThumbnailUrl,
  noticeText,
}: BenefitConfirmModalProps) {
  return (
    <div className={styles.benefitConfirmModal}>
      <ModalBase isOpen={isOpen} onClose={onClose}>
        <div className={styles.benefitConfirmModalContainer}>
          <div className={styles.benefitConfirmModalContent}>
            <p className={`${utilsStyles.textCenter} ${styles.drawCountText}`}>くじ引き回数：{drawCount}回</p>
            <p className={`${utilsStyles.textCenter} ${styles.benefitTitle}`}>獲得予定の特典</p>
            {benefitMultiDrawCount > 0 ? (
              <p className={styles.benefitWrapper}>
                <span className={fontsStyles.montserrat}>{benefitMultiDrawCount}</span>
                <small>連特典</small>
              </p>
            ) : (
              <div className={styles.noneWrapper}>
                <span className={styles.noneText}>なし</span>
              </div>
            )}
            <p className={`${styles.prizeName}`}>{prizeName}</p>
            {prizeThumbnailUrl && (
              <div className={`${styles.prizeImageContainer} ${utilsStyles.mtXSmall}`}>
                <ImageView src={prizeThumbnailUrl} alt={prizeName} objectFit='contain' />
              </div>
            )}
          </div>
          {noticeText && (
            <p className={`${utilsStyles.errorColor} ${styles.noticeText}`}>
              <FaIcon icon={faTriangleExclamation} />
              &nbsp;
              {noticeText.split('<br>').map((part, index, array) => (
                <React.Fragment key={part}>
                  {part}
                  {index < array.length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
          )}
          <div className={`${utilsStyles.mtXSmall} ${styles.confirmModalButtonsContainer}`}>
            <ActionButton color='warmgray' onClick={onClose}>
              キャンセル
            </ActionButton>
            <ActionButton color='primary' onClick={onConfirm}>
              OK
            </ActionButton>
          </div>
        </div>
      </ModalBase>
    </div>
  );
}

export default BenefitConfirmModal;
